import { Text } from "@primer/react";
import { TextProps } from '@primer/react/lib-esm';
import React from 'react';
export interface ITextProps extends TextProps {
    text: string
}
const MyText = React.memo((props: ITextProps) => {
    return (
        <Text sx={{
            ...props.sx,
        }}>
            {props.text}
        </Text>
    );
}, (prev, next) => {
    if (prev.text !== next.text) return false;
    if (prev.sx || next.sx) return false;
    return true;
});

export default MyText;